import React from 'react';
import './Modal.css';
import deleteIcon from "../../assets/images/deleteIcon_drawer.svg"
import Heading6Semibold from '../designSystem/Heading6Semibold';
import BodyMediumRegular from '../designSystem/BodyMediumRegular';
import BodyExtraSmallMedium from '../designSystem/BodyExtraSmallMedium';

const DeleteVisitModal = ({ isVisible, onClose, onDeleteClick, isLoading }) => {
    return (
        isVisible && (
            <div className="modal-backdrop">
                <div className="modal-container" onClick={(e) => e.stopPropagation()}>
                    <div className='content-container'>
                        <div className='icon-container'>
                            <img src={deleteIcon} />
                        </div>
                        <div className='text-container'>
                            <Heading6Semibold color='#1E293B' text='Delete Visit' />
                            <BodyMediumRegular
                                color='#384153'
                                text='This action will generate tasks for every added plan, you can always edit tasks in the task list.'
                                textAlign='center'
                            />
                        </div>
                    </div>
                    <div className='button-contiainer'>
                        <button className='cancel-button'
                            onClick={onClose}
                        >
                            <BodyExtraSmallMedium color='#1E293B' text='Cancel' />
                        </button>
                        <button className='danger-button' onClick={onDeleteClick} disabled={isLoading}>
                            <BodyExtraSmallMedium color='#FFFFFF' text='Delete Visit' />
                        </button>

                    </div>
                </div>
            </div>
        )
    );
};

export default DeleteVisitModal;
